import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "@pages/Login";

const routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" component={Login} />
    </Switch>
  );
};

export default routes;
